/* tslint:disable:no-consecutive-blank-lines */
/* tslint:disable:quotemark */
import { ILocaleData } from "../types";

const data: ILocaleData = {
	locale: "en",
	SummaryTitle: "Summary",
	SummaryDrawingTitle: "Drawing",
	ViewFullScreenMode: "View full screen",
	QuitFullScreenMode: "Exit full screen",
	ConfiguratorTitle: "Standard configuration",
	OptionsTitle: "Options",
	InstallationTitle: "Installation and shipping",
	NextQuestionLabel: "Next",
	NextStepLabel: "Next step",
	LastQuestion_Label: "View Quote",
	NewConfiguration: "Start new configuration",
	ConfiguratorProjectGroupTitle: "Project",
	ProjectNameTitle: "Project name",
	SummaryProject: "Project",
	SummaryRefNumber: "Ref#:",
	InstallationLocationTitle: "Ships To",
	InstallationLocationDescription:
		"Regulations differ from region to region, so it is necessary to know the location of the installation in order to provide you with the appropriate products.",
	InstallationLocationProvince: "Province",
	InstallationLocationState: "State",
	InstallationLocationSelectLabel: "Choose",
	InstallationLocationCity: "City",
	InstallationLocationNoResultDropdown:
		"No locations match the information entered. ",
	InstallationLocationNoResultAlert:
		"Installation and transportation costs for the selected region is not possible at this time. Please continue the configuration with the information entered and you will receive your quote within 1-2 business days.",
	InstallationLocationSummaryPendingLabel: "...",
	SeismicKitComboTitle: "Seismic kit option for the combo",
	SeismicKitRoomTitle: "Seismic kit option ",
	SeismicKitDescription:
		"Since the shipping address is located in <b>British Columbia</b>, the <b>seismic kit is systematically added</b> to your configuration. Seismic kit includes anchoring hardware to fix the walk-in to the building floor. However, it will be your responsibility if required by your customer to have a plan stamped by a local engineer.",
	SeismicKitAlertTitle: "Seismic kit",
	SeismicKitAlertDescription:
		"Depending on the seismic requirements related to the building or project, the installation of the cold room must respect seismic loads. This option makes it possible to meet these requirements by providing a system for anchoring the cold room to the ground. \r\n\r\nIf Seismic kit selected, drawing needs to be reviewed and stamped by local engineer overseeing project. \r\n",
	SeismicKitAlertTechnicalSheet: "Technical sheet",
	SummarySeismicKit: "Seismic kit",
	SummarySeismicKitPendingLabel: "...",
	ConfiguratorRoomsSelectionTitle: "ModaSPACE Walk-In",
	RoomNumberTitle: "Number of Walk-In Rooms",
	RoomsSelectionPendingLabel: "...",
	SummaryRoom: "Walk-In Cooler",
	SummaryRooms: "Walk-In Coolers",
	RoomTypeTitle: "Select a Walk-In type",
	RoomTypeFridgeLabel: "Cooler",
	BERoomTypeName1: "Cooler",
	BERoomTypeDesc1: "2°C / 35°F",
	RoomTypeWithoutFloorLabel: "Without floor",
    DoorWithoutRampLabel: "Without ramp",
	BERoomTypeName2: "Cooler",
	BERoomTypeDesc2: "2°C / 35°F",
	RoomTypeWithFloorLabel: "With floor",
    DoorWithRampLabel: "With ramp",
	BERoomTypeName3: "Freezer",
	BERoomTypeDesc3: "-18°C / 0°F",
	BERoomTypeName4: "Freezer",
	BERoomTypeDesc4: "-23°C / -10°F",
	DoorWallFreezerWarningText:
		"<b>Warning!</b> A door cannot swing inward a <b>freezer</b> room from a <b>cooler</b> room.",
	RoomTypeModifyAlertCA:
		"<b>Warning!</b> This is your last chance to modify the <b>country</b>, <b>province</b>, <b>number of rooms</b> and <b>room type</b> before the next step. These choices will be locked afterwards. ",
	RoomTypeModifyAlertUS:
		"<b>Warning!</b> This is your last chance to modify the <b>country</b>, <b>province</b>, <b>number of rooms</b> and <b>room type</b> before the next step. These choices will be locked afterwards. ",
	ConfiguratorDimensionsGroupTitle: "Dimensions",
	InteriorWidthComboTitle: "Interior width of each room",
	InteriorWidthComboSubTitle:
		"Please select the letter of each room to change their corresponding width.",
	InteriorWidthRoomTitle: "Interior width of the room",
	ExteriorWidthComboTitle: "Total overall width of the combo",
	ExteriorWidthRoomTitle: "Overall external width of the room",
	ExteriorWidthDescription:
		'Takes into consideration the 4" thickness of the exterior walls and middle walls.',
	SummaryInteriorWidth: "Int. width of room",
	InteriorWidthPendingLabel: "...",
	SummaryTotalExteriorWidth: "Overall ext. width",
	ExteriorWidthPendingLabel: "...",
	InteriorDepthComboTitle: "Interior depth of the combo",
	InteriorDepthRoomTitle: "Interior depth of the room",
	InteriorDepthDescription: "The choice of depth is applied to all rooms.",
	ExteriorDepthTitle: "Overall exterior depth",
	ExteriorDepthDescription:
		'Takes into account the thickness of the 4" exterior walls.',
	SummaryTotalExteriorDepth: "Total overall depth",
	ExteriorDepthPendingLabel: "...",
	ExteriorHeightComboTitle: "Exterior height of the combo",
	ExteriorHeightRoomTitle: "Exterior height of the room",
	ExteriorHeightDescription:
		"The overall height takes into consideration the thickness of the ceiling, the floor and the floor spacers, if any. ",
	BERoomHeight1: "7'6\"",
	BERoomHeight2: "8'6\"",
	SummaryExteriorHeight: "Overall ext. height",
	ExteriorHeightPendingLabel: "...",
	ConfiguratorCoolingSystemGroup: "Types of refrigeration system",
	CoolingSystemComboTitle: "Select a system for the combo",
	CoolingSystemRoomTitle: "Select a system for the room",
	CoolingSystemDescription:
		"Norbec offers reliable refrigeration systems that save time and money in addition to ensuring the efficiency and performance of the cold room and a proper environment for food. Discover the benefits of having your refrigeration covered by Norbec by consulting the data sheets.",
	BECoolingTypeName1: "Conventional indoor",
	BECoolingTypeDesc1: "Conventional air-cooled indoor refrigeration system",
	CoolingSystemTechnicalSheet1: "Information sheet",
	BECoolingTypeName2: "Conventional outdoor",
	BECoolingTypeDesc2: "Conventional air-cooled outdoor refrigeration system",
	CoolingSystemTechnicalSheet2: "Information sheet",
	BECoolingTypeName3: "PRO3 Top Mount",
	BECoolingTypeDesc3:
		"This system combines an evaporator and a condensing unit into one unit expediting installation time and reducing refrigerant charge — saving time, money, and energy.",
	CoolingSystemTechnicalSheet3: "Information sheet",
	CoolingSystemAlertComboTitle:
		"I don't want any refrigeration system with my combo.",
	CoolingSystemAlertRoomTitle:
		"I don't want any refrigeration system with my room.",
	CoolingSystemAlertInsight: "Warning!",
	CoolingSystemAlertSubtitle:
		"Choose a refrigeration system with your cold room and save money.",
	CoolingSystemAlertDescription:
		"Choose a refrigeration system with your cold room and save on the overall price of your quote. We offer a one year warranty on parts and labour with our refrigeration systems. ",
	CoolingSystemAlertLearnMoreLabel: "Learn more about our service offers.",
	SummaryCoolingSystem: "Ref. Syst.",
	CoolingSystemPendingLabel: "...",
	CoolingSystemNoneLabel: "None",
	CoolingSystemChangedAlertText:
		"<b>Attention !</b> Since you have made a change related to the type of refrigeration system, you must answer the following questions, i.e. the <b>distance between the condenser and the evaporator</b> and the <b>options of the refrigeration system</b>.",
	CondenserDistanceComboTitle:
		"Distance between condensing unit and evaporator for combo unit",
	CondenserDistanceRoomTitle:
		"Distance between condensing unit and evaporator for the room ",
	CondenserDistanceConventionalIntDescription:
		"The total distance of the refrigeration lines includes vertical and horizontal portions. For example, if the system is on another floor, the vertical distance must be planned accordingly.  ",
	CondenserDistanceConventionalExtDescription:
		"The total distance of the refrigeration lines includes vertical and horizontal portions. For example, if the system is on another floor, the vertical distance must be planned accordingly.  ",
	CondenserDistancePendingLabel: "...",
	SummaryCondenserDistance: "of distance",
	CoolingSystemOptionComboTitle: "Options for the combo",
	CoolingSystemOptionRoomTitle: "Options for the room",
	CoolingSystemOptionNotMandatoryDescription:
		"En - Puisqu'aucune chambre ne possède de système de réfrigération, il est possible d'ajouter ces options dolor sit amet pour le combo. Pour ajouter l'option LDA, l'option IntellirefV2 doit être ajoutée. De plus, pour le Data logging, l'option LDA doit être activée.",
	CoolingSystemOptionMandatoryDescription:
		"Norbec's conventional refrigeration units are equipped with the IntellirefV2 system (IntellirefV2 Low Temperature with freezer units), which electronically controls operating temperature and defrost cycles. Option can be added with IntellirefV2 to prevent food loss, save costly service calls and meet health and safety requirements.",
	CoolingSystemOptionMandatoryConventionalOnly:
		"Important: the choices made apply only to conventional systems.",
	CoolingSystemOptionTechnicalSheetLabel1: "IntellirefV2 technical sheet",
	BEIntellirefName1: "INTELLIREFV2",
	BEIntellirefDesc1:
		"An integrated electronic module designed to simplify refrigeration control by combining the functions of a thermostat and a defrost timer.",
	BEIntellirefName2: "LDA ",
	BEIntellirefDesc2:
		"Local Area Dashboard & Alarms. It allows to locally view all of the controllers in a single dashboard.  Sends Email & text alarms for all connected controllers to multiple email recipients.",
	CoolingSystemOptionTechnicalSheetLabel2: "Technical sheet",
	BEIntellirefName3: "Data logging",
	BEIntellirefDesc3:
		"Keep 366 days of data, for up to 10 devices, for intervals of 5 minutes to 24 hours between data points.",
	CoolingSystemOptionTechnicalSheetLabel3: "Technical sheet",
	BEIntellirefName4: "EM-PLUS",
	BEIntellirefDesc4:
		"The Edge Manager EM-PLUS allows to locally view all of the controllers in a single dashboard. It will send you information on the status of the alarm, evaluate the urgency level & troubleshoot at distance if necessary.",
	CoolingSystemOptionTechnicalSheetLabel4: "Technical sheet",
	CoolingSystemOptionPendingLabel: "IntellirefV2\r\n...",
	PriceButtonText: "See price",
	PriceAlertDefaultOptionsAndShipping:
		"The total price is calculated according to the options selected above.",
	PriceConfigurationLabelBloc1: "Configuration",
	PriceRefrigerationLabelBloc2: "Refrigeration",
	PriceInstallationLabelBloc3: "Installation",
	PriceDefaultLabelBloc3: "Default",
	PriceSavingsLabel: "Savings",
	PriceSavingsDetailsLabel: "Savings Details",
	PriceNoSavingsText:
		"Get up to 5% savings by choosing the PRO turnkey service.",
	PriceNoSavingsBtnLabel: "Save More With The Services Packages",
	PricePremiumOptionsLabelBloc4: "Premium Options",
	PriceDefaultLabelBloc4: "Default",
	PriceShippingLabelBloc5: "Shipping",
	PriceDefaultLabelBloc5: "Default",
	PriceTotalPriceLabel: "Total Price",
	PriceCadTaxesLabel: "CAD, plus taxes",
	PriceUsdTaxesLabel: "USD, plus taxes",
	PriceAlertNoBloc3CalculationFromCity:
		"Installation cost for the selected region is not possible at this time. ",
	PriceAlertNoSavingCalculationFromCity: "Installation price to be added",
	PriceNoSavingCalculationBtnLabel: "More information on service offerings",
	PriceAlertNoBloc5CalculationFromCity:
		"Transport cost for the selected region is not possible at this time. Please continue the configuration, you will receive your quote within 1-2 business days.",
	PriceAlertNoInstallationAndShippingCalculation:
		"Excludes the price of shipping and installation.",
	PriceAlertNoShippingCalculation: "Excludes shipping costs.",
	PriceAlertNoInstallationCalculation: "Excludes installation costs.",
	DoorsWallSelectionLabel: "Doors",
	DoorsWallSelectionEachDoorTitle: "Wall where each door is located",
	DoorsWallSelectionSingleDoorTitle: "Wall where the door is located",
    DoorsRampeEachDoorTitle: "Adding an interior ramp",
    DoorsRampeCheckBoxTitle: "Interior ramp",
	DoorsWallSelectionSubTitle:
		"A door must have a master room, from which the door opens outwards or to another room.",
	DoorsWallSelectionRoomAWall1: "Wall #1",
	DoorsWallSelectionRoomAWall1Desc: "Outward swing on front wall",
	DoorsWallSelectionRoomAWall2: "Wall #2",
	DoorsWallSelectionRoomAWall2Desc: "Opening to room B",
	DoorsWallSelectionRoomAWall3: "Wall #3",
	DoorsWallSelectionRoomAWall3Desc: "Outward swing on back wall",
	DoorsWallSelectionRoomAWall4: "Wall #4",
	DoorsWallSelectionRoomAWall4Desc: "Outward swing on left wall",
	DoorsWallSelectionRoomBWall5: "Wall #5",
	DoorsWallSelectionRoomBWall5Desc: "Outward swing on front wall",
	DoorsWallSelectionRoomBWall6: "Wall #6",
	DoorsWallSelectionRoomBWall6Desc: "Opening to room C",
	DoorsWallSelectionRoomBWall7: "Wall #7",
	DoorsWallSelectionRoomBWall7Desc: "Outward swing on back wall",
	DoorsWallSelectionRoomBWall2: "Wall #2",
	DoorsWallSelectionRoomBWall2Desc: "Opening to room A",
	DoorsWallSelectionRoomCWall8: "Wall #8",
	DoorsWallSelectionRoomCWall8Desc: "Outward swing on front wall",
	DoorsWallSelectionRoomCWall9: "Wall #9",
	DoorsWallSelectionRoomCWall9Desc: "Opening to room D",
	DoorsWallSelectionRoomCWall10: "Wal #7",
	DoorsWallSelectionRoomCWall10Desc: "Outward swing on back wall",
	DoorsWallSelectionRoomCWall6: "Wall #6",
	DoorsWallSelectionRoomCWall6Desc: "Opening to room B",
	DoorsWallSelectionRoomDWall11: "Wall #11",
	DoorsWallSelectionRoomDWall11Desc: "Outward swing on front wall",
	DoorsWallSelectionRoomDWall12: "Wall #12",
	DoorsWallSelectionRoomDWall12Desc: "Outward swing on right wall",
	DoorsWallSelectionRoomDWall13: "Wall #13",
	DoorsWallSelectionRoomDWall13Desc: "Outward swing on back wall",
	DoorsWallSelectionRoomDWall9: "Wall #9",
	DoorsWallSelectionRoomDWall9Desc: "Opening to room C",
	DoorsWidthEachDoorTitle: "Width of each door opening",
	DoorsWidthSingleDoorTitle: "Width of the door opening",
	DoorsWidthDefaultLabel: "...",
	DoorsPositioningEachDoorTitle:
		"Position of each door in relation to the middle walls",
	DoorsPositioningSingleDoorTitle:
		"Position of the door in relation to the middle walls",
	DoorsPositioningDescription:
		"Move the position of the door with the cursor. Note that the first movement of the corner of the room is 8 inches.  All subsequent positions will be in 4 inch increments.  ",
	DoorsPositioningPendingLabel: "...",
	DoorsPositioningCenterLabel: "Centered",
	DoorsPositioningSummary: "from left wall",
	DoorsOpeningDirectionEachDoorTitle: "Opening direction of each door",
	DoorsOpeningDirectionSingleDoorTitle: "Opening direction of the door",
	DoorsOpeningDirectionRoomALeftHinge: "Door A - Left Hinged",
	DoorsOpeningDirectionRoomALeftHingeDesc:
		"Handle on the right - Opening to the left",
	DoorsOpeningDirectionRoomARightHinge: "Door A - Right Hinged",
	DoorsOpeningDirectionRoomARightHingeDesc:
		"Handle on the left - Opening to the right",
	DoorsOpeningDirectionRoomBLeftHinge: "Door B  - Left Hinged",
	DoorsOpeningDirectionRoomBLeftHingeDesc:
		"Handle on the right - Opening to the left",
	DoorsOpeningDirectionRoomBRightHinge: "Door B - Right Hinged",
	DoorsOpeningDirectionRoomBRightHingeDesc:
		"Handle on the left - Opening to the right",
	DoorsOpeningDirectionRoomCLeftHinge: "Door C  - Left Hinged",
	DoorsOpeningDirectionRoomCLeftHingeDesc:
		"Handle on the right - Opening to the left",
	DoorsOpeningDirectionRoomCRightHinge: "Door C - Right Hinged",
	DoorsOpeningDirectionRoomCRightHingeDesc:
		"Handle on the left - Opening to the right",
	DoorsOpeningDirectionRoomDLeftHinge: "Door D  - Left Hinged",
	DoorsOpeningDirectionRoomDLeftHingeDesc:
		"Handle on the right - Opening to the left",
	DoorsOpeningDirectionRoomDRightHinge: "Door D - Right Hinged",
	DoorsOpeningDirectionRoomDRightHingeDesc:
		"Handle on the left - Opening to the right",
	DoorsOpeningDirectionDefaultLabel: "...",
	DoorsOpeningDirectionRightHinge: "Right Hinged",
	DoorsOpeningDirectionLeftHinge: "Left Hinged",
	DoorsOptionsEachDoorTitle: "Increase Efficiency with these Door Options",
	DoorsOptionsSingleDoorTitle: "Increase Efficiency with these Door Options",
	DoorsOptionsPedal: "Foot Pedal",
	BEDoorPedalName: "Foot Pedal",
	BEDoorPedalUnit: "door",
	BEDoorPedalDesc: "Foot pedal for hands-free opening.",
	DoorsOptionsTechnicalSheetPedal: "Information sheet",
	DoorsOptionsCurtain: "Strip Curtains",
	BEDoorCurtainName: "Strip Curtains",
	BEDoorCurtainUnit: "door",
	BEDoorCurtainDesc:
		"Maintain constant temperature, reduce energy loss and minimize insect and dust infiltration.",
	DoorsOptionsTechnicalSheetCurtain: "Information sheet",
	DoorsOptionsWindow: "Window",
	BEDoorWindowName: "Window",
	BEDoorWindowUnitLabel: "door",
	BEDoorWindowDesc:
		"Enhance functionality, security and product visibility. \r\nDimension: 15'' x 20''",
	DoorsOptionsTechnicalSheetWindow: "Information sheet",
	DoorsOptionsKickplate: "Kick plates",
	BEDoorKickplateName: "Kick plates int. & ext.",
	BEDoorKickplateUnit: "door",
	BEDoorKickplateDesc:
		"Installed on the interior and exterior of the door, the protective kick-plates protect against impacts and ensure a better longevity of the door.\r\nHeight: 36''",
	DoorsOptionsTechnicalSheetKickplate: "Information sheet",
	DoorsI3OptionComboTitle: "IM4 Option for the combo",
	DoorsI3OptionRoomTitle: "IM4 Option for the room",
	DoorsI3OptionEachDoorDescription:
		"Since the delivery address is located in <b>British Columbia</b>, the <b>IM4 option</b> must be added to your configuration for each door.",
	DoorsI3OptionSingleDoorDescription:
		"Since the delivery address is located in <b>British Columbia</b>, the <b>IM4 option</b> must be added to your configuration.",
	BEDoori3Name: "IM4",
	BEDoorI3Unit: "door",
	BEDoori3Desc:
		"The IM4 monitor is used to manage and control alarms such as temperature alarms, open door alarms and panic alarms. It allows for simpler, more efficient energy management.",
	DoorsI3OptionTechnicalSheetLabel: "Technical sheet",
	DoorsI3OptionPendingLabel: "...",
	DoorsI3OptionSummary: "IM4",
	FloorGroup: "Floor",
	FloorMaterialComboTitle: "Floor type for the combo",
	FloorMaterialRoomTitle: "Floor type for the room",
	FloorMaterialDescription:
		'By default, a room with a floor also has a floor spacer.  A floor is 4" high and the floor spacer is 1" high.  These dimensions are taken into consideration in the exterior height of the room.',
	FloorMaterialTechnicalSheetLabel: "Technical sheet",
	BEFloorMaterialName1: "Galvanized steel",
	FloorMaterialIncludedLabel: "Included",
	BEFloorMaterialName2: "Aluminum",
	BEFloorMaterialDesc2: "NSF Certified",
	BEFloorMaterialUnit: "floor",
	FloorMaterialSummary: "Floor",
	FloorTextureComboTitle: "Floor finishes for the combo",
	FloorTextureRoomTitle: "Floor finishes for the room",
	BEFloorTextureName1: "Smooth",
	BEFloorTextureDesc1: "Standard smooth finish",
	BEFloorTextureName2: "NextGrip slip-resistant floor",
	BEFloorTextureDesc2:
		"NextGrip non-slip flooring has an embossed pattern to provide better grip to reduce the risk of slips and falls.",
	FloorTextureTechnicalSheet2: "Technical sheet",
	LightsOptionsGroup: "Lighting",
	LightsOptionsComboTitle: "Lighting models for each room",
	LightsOptionsRoomTitle: "Lighting models for the Walk-In",
	LightsOptionsDescription:
		"One light per 100 sq. ft. of ceiling area is automatically calculated. You have the possibility of enhancing this option with the 1809 LED light.  ",
	BERoomLightName1: "LED 1808",
	BERoomLightUnit1: "Included",
	BERoomLightDesc1:
		"Bright, long-lasting and energy efficient LED lighting. ",
	LightsOptionsTechnicalSheet: "Information sheet",
	BERoomLightName2: "LED 1809",
	BERoomLightUnit2: "light",
	BERoomLightDesc2:
		"This new model is just 18''x5'' and emits more light than a 4' long LED light, offering a wider spectrum of light.  This model provides 50,000 hours of light. ",
	LightsOptionsSummary: "Lighting",
	MotionDetectorOptionComboTitle: "Motion sensor for each room",
	MotionDetectorOptionRoomTitle: "Motion sensor for the room",
	BERoomDetectorName: "Kason 1901-5 Motion sensor",
	BERoomDetectorUnitLabel: "room",
	BERoomDetectorDesc:
		"Assure safety and energy efficiency. Add a motion sensor and the light will turn on when someone is present and turn off automatically after a programmed time delay. ",
	MotionDetectorTechnicalSheet: "Technical sheet",
	MotionDetectorPendingLabel: "...",
	MotionDetectorSummary: "Motion sens.",
	InstallationInstallationTagLabel: "Installation",
	InstallationInstallationTitle: "A Turnkey Installation Service ",
	InstallationInstallationTitleNotAvailable:
		"A Turnkey Installation Service (Currently not available in your area)",
	InstallationInstallationCheckboxTittle:
		"I choose the installation service ",
	InstallationInstallationCheckboxDescription:
		"Entrust Norbec with the installation of your cold room and save 5% on the overall price of your quote. All our installations, parts and labour are guaranteed for one year. This turnkey service gives you peace of mind and ensures a superior quality installation.",
	InstallationInstallationLearnMoreLabel:
		"Learn more about our service offers.",
	InstallationInstallationCheckboxAlertSubtitle:
		" If you do not take the installation service, the warranty may vary. ",
	InstallationInstallationCheckboxAlertInsight: "Warning!",
	InstallationInstallationCheckboxAlertDescription:
		"Walk-in coolers are an investment that need to resist to most of the abuse of day-to-day traffic. Installation is a key factor in standing the test of time. Trust our experienced installers. They will carry out your installation using proven methods and according to the highest standards to ensure superior durability and performance.",
	InstallationInstallationTitleSummary: "Installation",
	InstallationInstallationLabelYesSummary: "Yes - Norbec",
	InstallationInstallationLabelNoSummary: "No",
	DeliveryChoiceTitle: "Freight Options",
	DeliveryChoiceDeliveryByNorbecTitle: "Delivery by Norbec",
	DeliveryChoiceDeliveryByNorbecText:
		"Norbec takes care of all the logistics surrounding transportation for your peace of mind.  Our team takes care of choosing the right type of vehicle for your order, follows up on the delivery and ensures that the merchandise is delivered to the right place and on time. Norbec's delivery service saves time and provides quality service.",
	DeliveryChoiceDeliveryPickUpAtNorbecTitle: "Pick-up at Norbec",
	DeliveryChoiceDeliveryPickUpAtNorbecText:
		"To pick up your order at Norbec, please make an appointment with the shipping department by email at transport@norbec.com or at 1800-667-2321 #2304 a minimum of 48 hours in advance. ",
	DeliveryDateTitle: "Delivery date",
	DeliveryDateDesiredDay: "Requested day",
	DeliveryDateByNorbecDescription:
		"Specify the desired delivery date. This date is an approximate date and is for information purposes only.  ",
	DeliveryDatePickUpDescription:
		"EN - Indiquez la date de ramassage souhaitée. Cette date est une date approximative et est à titre indicatif seulement.",
	DeliveryDatePickUpAddressTitle: "Pick-up address",
	DeliveryDatePickUpAddressPlace:
		"<address>Norbec Shipping Department<br/>80 J-A Bombardier, Door #5<br/>Boucherville, Quebec, Canada<br/>J4B 8N4</address>",
	DeliveryDatePickUpAddressHour:
		"<time>8:00 am - 4:00 pm ET<br/>Monday to Friday</time>",
	DeliveryDatePlaceholder: "DD-MM-YY",
	DeliveryDateSummaryPending: "...",
	ShippingContactTagLabel: "Freight Details",
	ShippingContactTitle: "Delivery contact",
	ShippingContactText:
		"Please provide the contact details of the person who will be responsible for the delivery.",
	ShippingContactInputNameLabel: "Contact person's name",
	ShippingContactInputPhoneLabel: "Phone",
	ShippingContactInputPhoneExtLabel: "Extension",
	ShippingContactInputEmailLabel: "Email",
	ShippingLocationTitle: "Shipping location",
	ShippingLocationCivicAddress: "Civic address",
	ShippingLocationText:
		"Please fill out the information below to obtain a freight quote for the selected region. If we are not able to calculate the freight cost for the selected location, we will send you a quote within 1 to 2 business days.",
	ShippingLocationAddressLabel: "Address, Street, Office",
	ShippingLocationAddressAdditionalInfoLabel:
		"Address - Additional information",
	ShippingLocationCityLabel: "City",
	ShippingLocationCityDropdownWarningText:
		"Please note, if you change the city of the delivery location, the shipping costs may change. ",
	ShippingLocationCityDropdownNotFound:
		"No locations match the information entered.",
	ShippingLocationCityNoCalculationText:
		"Installation & freights costs for the selected region can not be calculated at this time. Please continue the configuration with the information entered and you will receive your quote within 1-2 business days.",
	ShippingLocationPostalCodeLabel: "Postal Code",
	ShippingLocationPostalCodePlaceholder: "A0A 0A0",
	ShippingLocationPostalCodeError: "The postal code is not valid",
	ShippingLocationZipCodeLabel: "Zip code",
	ShippingLocationZipCodePlaceholder: "00000",
	ShippingLocationZipCodeError: "The Zip code is not valid",
	ShippingLocationLockSectionSubtitle: "Information Locked",
	ShippingLocationLockSectionProvinceLabel: "Province",
	ShippingLocationLockSectionCountryLabel: "Country",
	ShippingLocationSummaryPending: "...",
	QuoteTagLabel: "Quote",
	QuoteMainTitle: "Contact details and information",
	QuoteDescription:
		"Please enter the contact details and information of the recipient of the quote. ",
	QuoteClientSectionTitle: "Customer Contact Information",
	QuoteClientSectionBusinessInputLabel: "Business",
	QuoteClientSectionNameInputLabel: "Contact person's name",
	QuoteClientSectionPhoneInputLabel: "Phone",
	QuoteClientSectionPhoneInputError: "The Phone number is not valid",
	QuoteClientSectionExtensionInputLabel: "Extension",
	QuoteClientSectionExtensionInputError: "The extension is not valid",
	QuoteClientSectionEmailInputLabel: "Email",
	QuoteClientSectionEmailInputError: "The email is not valid",
	QuoteRepresentativeSectionTitle:
		"Norbec representative's contact information",
	QuoteRepresentativeSectionNameInputlabel: "Representative's name",
	QuoteRepresentativeSectionEmailInputlabel: "Representative's email",
	QuoteRepresentativeSectionEmailInputError: "The email is not valid",
	QuotePercentageInputText:
		"Add an additional margin percentage on the quote.",
	QuotePercentageInputLabel: "Markup percentage",
	QuotePercentageInputError: "The percentage is not valid",
	QuoteProjectManagerSectionTitle:
		"Contact information for Norbec project manager",
	QuoteProjectManagerInputNameLabel: "Project Manager's name",
	QuoteProjectManagerInputemailLabel: "Project Manager's email",
	QuoteLanguageSectionTitle: "Language of communication",
	QuoteLanguageSectionDescription:
		"Please select the language in which the submission will be generated",
	QuoteLanguageSectionCheckboxFrLabel: "French",
	QuoteLanguageSectionCheckboxEnLabel: "English",
	QuoteLaunch: "Launch quote",
	QuoteMissingCoolingSystemWarning:
		"Warning! Your <b>refrigeration system</b> selection was invalidated due to changes made to the rooms' dimensions. You must complete your <b>refrigeration system</b> selection to launch the quote.",
	ConfirmationTagLabel: "Confirmation",
	ConfirmationMainTitle:
		"Your quote for the <b>ModaSPACE</b> cold room has been completed.",
	ConfirmationTextIntro:
		"To process this project as an order, please email us your Purchase Order and signed approval drawings. Approval drawings are located on the last page of the quote. Thank you for your business. - The Norbec Team.",
	ConfirmationBtnRelanchQuoteLabel: "Relaunch quote",
	ConfirmationSubtitleConfirmationPage: "Questions? Contact us now!",
	ConfirmationTextConfirmationPage:
		'Email us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a>',
	ConfirmationNorbecPhoneConfirmationPage:
		'<a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>',
	ConfirmationAlertTitleNoCalculation: "Total Price",
	ConfirmationAlertTextNoCalculation:
		"Since freight and installation costs could not be calculated, you will receive your completed quote within 1 to 2 business days.",
	EmailNorbecQuoteModaSpace: "Norbec Quote - ModaSPACE",
	Emailgreetings: "Hi,",
	EmailTitleSingleRoom:
		"Thank You! Your quote for the <b>ModaSPACE</b> cold room has been completed.",
	EmailTitleManyRooms:
		"Thank You! Your quote for the <b>ModaSPACE</b> cold rooms has been completed.",
	EmailTextConfirmation:
		"To place an order, please email your project manager a purchase order and signed approval drawings. The approval drawings are located on the last page of the submission. Thank you for your business. -The Norbec Team",
	EmailButtonRelanchQuote: "Relaunch Quote",
	EmailSubtitleConfirmation: "Questions? Contact us now!",
	EmailTextSubtitleConfirmation:
		'Email us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a>',
	EmailPhoneNumber:
		'<a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>',
	EmailTotalPricelabel: "Total Price",
	EmailAlertTextNoCalculation:
		"Since freight and/or installation costs could not be calculated, you will receive your completed quote within 1 to 2 business days.",
	EmailLegalText:
		"© 2020, Norbec all Rights Reserved. Terms of use. Privacy policy.",
	VariablePhoneNumberSizeIt: "1-833-396-2321",
	VariableEmailSizeIt: "sizeit@norbec.com",
	GeneralNo: "No",
	GeneralYes: "Yes",
	GeneralValidate: "Validate",
	GeneralClose: "Close",
	GeneralLoading: "Loading",
	GeneralAllRooms: "All rooms",
	GeneralInch: '"',
	GenralFeet: "'",
	GeneralByDefault: "by default",
	GeneralMin: "MIN",
	GeneralMax: "MAX",
	GeneralView: "See",
	GeneralDropdownNoOptions: "No options",
	GeneralDropdownChoosePlaceholder: "Choose",
	GeneralCombo: "Combo",
	GeneralRoom: "Cold room",
	GeneralDoor: "Door",
	GeneralLimit: "LIMIT",
	GeneralCenter: "CENTER",
	GeneralOverwriteAlertKeyword: "Warning!",
	GeneralOverwriteAlertDescription:
		"Please choose the selection that will apply to all rooms. ",
	GeneralContinue: "Continue",
	GeneralSave: "Save",
	GeneralCreate: "Create",
	GeneralCancel: "Cancel",
    GeneralSend: "Send",
	GeneralIncluded: "Included",
	GeneralOptionalField: "Optional",
	GeneralAdd: "Add",
	GeneralModify: "Modify",
	GeneralEnter: "Enter",
	GeneralErrorMessageRequiredField:
		"Attention, this information is mandatory to proceed to the next step.",
	GeneralDownload: "Download",
	GeneralPrice: "Price",
	GeneralFormSubmitMessageSuccess: "The information was successfully saved",
	GeneralFormSubmitMessageError: "An error occured",
	GeneralDatePlaceholder: "YYYY-MM-DD",
	NotFound404: "404 Not Found",
	NotFoundOops: "Oops",
	NotFoundTitle: "Sorry we could not find what you were looking for!",
	NotFoundText:
		"Please check the URL you entered for errors or try to return to a previous page in the browser to continue the configuration.",
	NotFoundReturnLink: "Back to configuration",
	NotAccessibleOops: "Oops!",
	NotAccessibleTitle:
		"The page you are looking for does not seem to be accessible.",
	NotAccessibleText:
		"Please check the URL you entered for errors or return to the home page.",
	NotAccessibleLabel: "Page non accessible",
	NotAccessibleReturnLink: "Back to configuration",
	ErrorSystemModalTagLabel: "Oops",
	ErrorSystemModalTitle: "A system error occurred.",
	ErrorSystemModalText:
		'If you are unable to return to the current configuration, contact technical support at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a> or <a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>, quoting the reference number.',
	ErrorSystemModalButtonText: "Refresh page",
	BEUnitIncluded: "Included",
	BEUnitDoor: "door",
	BEUnitFloor: "floor",
	BEUnitLight: "light",
	BEUnitRoom: "room",
	BEUnitCombo: "combo",
	CAN: "Canada",
	USA: "United-States",
	AB: "Alberta",
	BC: "British Columbia",
	MB: "Manitoba",
	NB: "New Brunswick",
	NL: "Newfoundland and Labrador",
	NS: "Nova Scotia",
	ON: "Ontario",
	PE: "Prince Edward Island",
	QC: "Quebec",
	SK: "Saskatchewan",
	NT: "Northwest Territories",
	NU: "Nunavut",
	YT: "Yukon Territory",
	AL: "Alabama",
	AK: "Alaska",
	AZ: "Arizona",
	AR: "Arkansas",
	CA: "California",
	CO: "Colorado",
	CT: "Connecticut",
	DE: "Delaware",
	FL: "Florida",
	HI: "Hawaii",
	ID: "Idaho",
	IL: "Illinois",
	IN: "Indiana",
	IA: "Iowa",
	KS: "Kansas",
	KY: "Kentucky",
	LA: "Louisiana",
	ME: "Maine",
	MD: "Maryland",
	MA: "Massachusetts",
	MI: "Michigan",
	MN: "Minnesota",
	MS: "Mississippi",
	MO: "Missouri",
	MT: "Montana",
	NE: "Nebraska",
	NV: "Nevada",
	NH: "New Hampshire",
	NJ: "New Jersey",
	NM: "New Mexico",
	NY: "New York",
	NC: "North Carolina",
	ND: "North Dakota",
	OH: "Ohio",
	OK: "Oklahoma",
	OR: "Oregon",
	PA: "Pennsylvania",
	RI: "Rhode Island",
	SC: "South Carolina",
	SD: "South Dakota",
	TN: "Tennessee",
	TX: "Texas",
	UT: "Utah",
	VT: "Vermont",
	VA: "Virginia",
	WA: "Washington",
	WV: "West Virginia",
	WI: "Wisconsin",
	WY: "Wyoming",
	NDEF: "Undefined",
	US01: "New England",
	US02: "NY (upstate) - W. Pennsylvania",
	US03: "New York Metro",
	US04: "Keystone",
	US05: "Mid-Atlantica",
	US06: "Michigan/Indiana",
	US07: "Mid-America",
	US11: "Carolinas",
	US12: "Southeast Central",
	US13: "Florida",
	US14: "South Central",
	US15: "Texas/Oklahoma",
	US16: "Mid-Central",
	US17: "Chicago Metro",
	US18: "Wisconsin/Upper Michigan",
	US19: "Upper Mid-Central",
	US20: "Mountain States North",
	US21: "Arizona/New Mexico",
	US22: "Southern California",
	US24: "San Francisco Metro",
	US25: "Northwest",
	PdfTestEnvironment: "Test environment - not a legal quote",
	PdfDateFormat: "yyyy-MM-dd",
	PdfTimeFormat: "h:mm aa",
	PdfFilenameDateFormat: "yyyy-MM-dd HH-mm",
	PdfNoValue: "–",
	PdfGenerating: "Preparing document...",
	PdfByNorbec: "By Norbec",
	PdfRefNumber: "Quote",
	PdfInternalQuoteNum: "Internal quote num",
	PdfQuoteDate: "Quote date",
	PdfActionButtonSendByEmailText: "Send by email ",
	PdfActionButtonSendByEmailMessageSuccess: "Email was sent successfully",
	PdfActionButtonSendByEmailMessageError: "An error occurred",
	PdfActionButtonFillAndSendText: "Complete and sign",
	PdfTopNoticeQuoteBeenCompletedTitle:
		"Quote for the ModaSPACE cold room has been completed.",
	PdfTopNoticeRefNumberLabel: "Reference #",
	PdfTopNoticeTextNoCalculation:
		"Since freight and/or installation costs could not be calculated, you will receive your complete quote within 1 to 2 business days. ",
	PdfTopNoticeOrderedTitle: "This configuration is on ''order''",
	PdfTopNoticeOrderedText:
		"You will receive an email when the order is confirmed and placed in production. Contact your representative for any other questions.",
	PdfTopNoticeCompleteText:
		"To process this project as an order, please <b> complete and sign </b> the quote.",
	PdfDoneBy: "Configuration done by",
	PdfAddress: "97 rue de Vaudreuil, Boucherville QC, Canada, J4B 1K7",
	PdfContact: "Phone : 450-449-1499  |  </b>norbec.com</b>",
	PdfPage: "Page",
	PdfQuoteFor: "Quote for",
	PdfClient: "Customer",
	PdfProject: "Project",
	PdfContactAddress: "Customer address",
	PdfContactPhone: "Phone",
	PdfContactContact: "Contact",
	PdfModalSendByEmail: "Please choose the recipients",
	PdfModalMultipleInputEmailsTitle: "Add other recipients",
	PdfModalMultipleInputEmailsPlaceholder: "Input your email",
	PdfShippingContact: "Delivery contact",
	PdfContactHashtag: "#",
	PdfContactFax: "Fax",
	PdfContactCellPhone: "Cell phone",
	PdfContactEmail: "Email",
	PdfContactDeliveryAddress: "Delivery address",
	PdfContactDeliveryDate: "Delivery date",
	PdfContactValidUntil: "Valid until",
	PdfContactTerms: "Terms",
	PdfContactNet: "Net",
	PdfContactDays: "days",
	PdfContactRep: "Norbec Representative\r\n",
	PdfContactPM: "Project Manager",
	PdfConfiguration: "Configuration",
	PdfConfigurationExtDimensions: " External dimension of the combo : ",
	PdfConfigurationExtRoomDimensions: "External dimension of the room : ",
	PdfConfigurationWidth: "Width",
	PdfConfigurationDepth: "Depth",
	PdfConfigurationHeight: "Height",
	PdfConfigurationFloorAluminum: "Aluminum 0.100'' floor",
	PdfConfigurationFloorGalvanized: "Galvanized steel floor",
	PdfConfigurationHinges: "Hinges #1248",
	PdfConfigurationHandle: "Handle  #1229C",
	PdfConfigurationDoorCloser: "Door closer #1095",
	PdfConfigurationGasket: "Magnetic gasket",
	PdfConfigurationPressureRelief: "Pressure relief vent if required",
	PdfConfigurationSeismicKit: "Seismic kit",
	PdfConfigurationSilkline: "White Silkline galvanized finish",
    PdfConfigurationReinforcedFloor: "Reinforced floor",
	PdfRoomTitle: "<b>ModaSPACE</b> Cold Room",
	PdfRoomType: "Type",
	PdfRoomTemperature: "Temperature",
	PdfRoomInteriorWidth: "Interior width",
	PdfRoomDoorWidth: "Door width",
	PdfRoomDoorOpeningWidth: "Opening width",
	PdfRoomDoorHeight: "Door height",
	PdfRoomDoorOpening: "Door opening",
	PdfRoomDoorOpeningDirection: "Opening direction",
	PdfRefrigeration: "Refrigeration",
	PdfRefrigerationType: "Type ",
	PdfRefrigerationNotSelected: "Not selected",
	BECoolingTypeName3ShortName: "PRO3",
	PdfRefrigerationSystem: "Pro3 Refrigeration system",
	BECoolingTypeName1ShortName: "Conv. in.",
	BECoolingTypeName2ShortName: "Conv. out.",
	PdfRefrigerationEvaporator: "Evaporator",
	PdfRefrigerationCondensingUnit: "Condensing unit ",
	PdfRefrigerationVoltage: "Voltage",
	PdfRefrigerationVoltageUnit: "V",
	PdfRefrigerationAmperage: "Amperage",
	PdfRefrigerationAmperageUnit: "AMP",
	PdfRefrigerationIntelliref: "IntellirefV2",
	PdfRefrigerationSeeClauses: "See refrigeration terms",
	PdfInstallation: "Installation",
	PdfInstallationAlert:
		"Installation cost for the selected region is not possible at this time. ",
	PdfInstallationEvapDistance: "Evap/cond distance",
	PdfInstallationConventionnalInterior:
		"Installation of Cold room and conventionnal interior refrigeration system",
	PdfInstallationConventionnalExterior:
		"Installation of Cold room and conventionnal exterior refrigeration system",
	PdfInstallationConventionnalInteriorExterior:
		"Installation of Cold room and Conventionnal interior + Conventionnal exterior refrigeration systems",
	PdfInstallationConventionnalInteriorExteriorPro3:
		"Installation of Cold room and Pro3 + Conventionnal interior + Conventionnal exterior refrigeration systems",
	PdfInstallationConventionnalInteriorPro3:
		"Installation of Cold room and Pro3 + Conventionnal interior refrigeration system",
	PdfInstallationConventionnalExteriorPro3:
		"Installation of Cold room and Pro3 + Conventionnal exterior refrigeration system",
	PdfInstallationNotSelected: "Not selected",
	PdfInstallationClauses: "See installation terms",
	PdfInstallationSavings: "Savings",
	PdfInstallationNoSavings: "–",
	PdfInstallationSavingPlanPro: "Package pro",
	PdfInstallationSavingPlanPlus: "Package plus",
	PdfInstallationSavingPlanStandard: "Package standard",
	PdfInstallationSavingPlanBase: "Package basic",
	PdfOptions: "Premium Options",
	PdfOptionsQuantity: "QTY",
	PdfOptionsUnit: "UOM",
	PdfOptionsA: "A",
	PdfOptionsB: "B",
	PdfOptionsC: "C",
	PdfOptionsD: "D",
	PdfOptionsUnitPrice: "Unit Price",
	PdfOptionsTotal: "Total",
	PdfOptionsDoorsOptions: "Door options",
	PdfOptionsPedal: "Foot treadle",
	PdfOptionsPedalUnit: "each",
	PdfOptionsCurtains: "Strip Curtains",
	PdfOptionsCurtainsUnit: "each",
	PdfOptionsWindow: "Window",
	PdfOptionsWindowUnit: "each",
	PdfOptionsKickPlates: "Kick plates",
	PdfOptionsKickPlatesUnit: "each",
	PdfOptionsI3: "Upgrade to IM4",
	PdfOptionsI3Unit: "each",
	PdfOptionsRefrigerationOptions: "Refrigeration Options",
	PdfOptionsLDA: "LDA",
	PdfOptionsLDAUnit: "each",
	PdfOptionsDataLogging: "Data logging",
	PdfOptionsDataLoggingUnit: "each",
	PdfOptionsEmPlus: "Em Plus",
	PdfOptionsEmPlusUnit: "each",
	PdfOptionsFloorOptions: "Floor Options",
	PdfOptionsNextGrip: "NextGrip",
	PdfOptionsNextGripUnit: "sqft",
    PdfOptionsRamp: "Ramp with floor reinforcement",
	PdfOptionsRampUnit: "inch",
	PdfOptionsLighting: "Lighting Options",
	PdfOptionsDEL1808: "Upgrade to LED #1808 light",
	PdfOptionsDEL1808Unit: "each",
	PdfOptionsDEL1809: "Upgrade to LED #1809 light",
	PdfOptionsDEL1809Unit: "each",
	PdfOptionsMotionSensor: "Motion sensor",
	PdfOptionsMotionSensorUnit: "each",
	PdfTransport: "Freight",
	PdfTransportNotAvailable:
		"Freight cost for the selected region is not possible at this time. ",
	PdfTransportWithInstall: "Freight with installation",
	PdfTransportWithoutInstall: "Freight without installation",
	PdfTransportTerms: "See freight terms",
	PdfTotal: "Grand total",
	PdfTotalCAD: "CAD, taxes not included",
	PdfTotalUSD: "USD, taxes not included",
	PdfTotalExcludeAll:
		"*Excludes the price of freight and installation. You will receive your quote within 1-2 business days.",
	PdfTotalExcludeTransport:
		"*Excludes the price of freight. You will receive your quote within 1-2 business days.",
	PdfTotalExcludeInstall:
		"*Excludes the price of installation. You will receive your quote within 1-2 business days.",
	PdfThankYou:
		"Thank you for the opportunity to quote on your project, please feel free to communicate with us if you have any questions.",
	PdfThankYouContactPhone:
		'<a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>',
	PdfThankYouContactEmail:
		'<a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a>',
	PdfDrawingInitialsLabel: "Initials",
	PdfDrawingTitle: "Approval drawings",
	PdfDrawingSignatureLabel: "Signature",
	PdfDrawingPoLabel: "PO",
	PdfDrawingDateLabel: "Date",
	PdfTermsTagLabel: "Annex",
	PdfTermsMainTitle: "Terms & Conditions",
	PdfTermsCoolingSystemSubtitle: "<b>Refrigeration Terms</b>",
	PdfTermsCoolingSystemGenericSubsubtitleLabel: "General Refrigeration Terms",
	PdfTermsCoolingSystemGenericText:
		"<ul>\r\n    <li>Capacities are calculated based on 32°C/90°F ambient temperature. Proper air flow around the unit to keep this\r\n        temperature to be provided by site or could affect performances and void warranties. Load calculation are done\r\n        for holding temperature.\r\n    </li>\r\n    <li>For self-contained type refrigeration unit (PRO3), although these unit are self contained, they must be started\r\n        up by a qualified refrigeration mechanic and a start up report must be filled out and returned to validate\r\n        warranty.\r\n    </li>\r\n    <li>Temperature of operation: Coolers 2°C/35°F – Freezers -18°C/0°F (optional -23°C/-10°F if selection was made in this\r\n        quote)\r\n    </li>\r\n    <li>Refrigeration unit support or sleepers or curbs are not included in this quote.</li>\r\n    <li>A start up report must be filled for all refrigeration install by a qualified technician even if Norbec is not\r\n        mandated for the installation of the refrigeration component. Failure to present this report will void any\r\n        warranty claim.\r\n    </li>\r\n</ul>",
	PdfTermsCoolingSystemIntExtSubsubtitleLabel:
		"<b>Remote</b> refrigeration Systems sold as parts only without installation ",
	PdfTermsCoolingSystemIntExtText:
		"<ul>\r\n    <li>Not included: piping, insulation, refrigerant, evaporator drain line.</li>\r\n    <li>Installation to be done by a qualified refrigeration company in accordance with all governing codes.</li>\r\n    <li>Refrigeration System warranty does not cover loss of products due to malfunction or failure of the system.</li>\r\n    <li>Warranty 1-year parts only..</li>\r\n</ul>",
	PdfTermsCoolingSystemPro3SubsubtitleLabel:
		"For Penthouse type <b>PRO3</b> Refrigeration Systems sold without installation ",
	PdfTermsCoolingSystemPro3Text:
		"<ul>\r\n    <li>This system must be operated by a certified refrigeration specialist. No warranty will be applicable without\r\n        proof of commissioning by a qualified technician.\r\n    </li>\r\n    <li>Warranty 1-year parts only.</li>\r\n</ul>",
	PdfTermsInstallationSubtitle: "<b>Installation terms</b>",
	PdfTermsInstallationSingleRoomSubsubtitleLabel:
		"Installation Cold Room Only  ",
	PdfTermsInstallationSingleRoomText:
		"<ul>\r\n    <li>Installation of cold room panels and doors as per plans and specifications received with the order. Installation\r\n        is done during normal business hours on weekdays.\r\n    </li>\r\n    <li>All electrical and plumbing connections are excluded.\r\n</li>\r\n</ul>",
	PdfTermsInstallationPro3SubsubtitleLabel:
		"Installation Cold Room and Penthouse type <b>PRO3</b> Refrigeration Systems ",
	PdfTermsInstallationPro3Text:
		"<ul>\r\n    <li>Installation of cold room panels and doors as per plans and specifications received with the order. Installation\r\n        is done during normal business hours on weekdays.\r\n    </li>\r\n    <li>Installation and start-up of a self-contained refrigeration unit on top of walk-in. All electrical and\r\n        plumbing connections are excluded. Please check the specification sheet associated with your refrigeration selection.  Heat rejection from these units must be properly exhausted from the top of the walk-in with the proper air supply or the warranty will be voided. \r\n    </li>\r\n</ul>",
	PdfTermsInstallationIntExtSubsubtitleLabel:
		"Installation Cold Room and <b>Conventional Indoor and Outdoor</b> Refrigeration Systems ",
	PdfTermsInstallationIntExtText:
		"<ul>\r\n    <li>Installation of cold room panels and doors as per plans and specifications received with the order. Installation\r\n        is done during normal business hours on weekdays.\r\n    </li>\r\n    <li>Installation of refrigeration systems within selected distance, if this distance changes due to site conditions,\r\n        price will have to be adjusted.\r\n    </li>\r\n    <li><b>Included:</b>\r\n<ul>\r\n    <li>Piping insulation.</li>\r\n    <li>Supply and install of drain line heater (freezer only).</li>\r\n    <li>Installation of the drain from the evaporator to the outlet of the cold room.</li>\r\n    <li>Refrigerant charge.</li>\r\n    <li>System balancing and start-up.</li>\r\n    <li>1-year labour warranty. </li>\r\n    <li>Rental of a crane for the units installated on the roof (if required).</li>\r\n    <li></ul>\r\n    <li><b>Excluded:</b> \r\n<ul>\r\n    <li>Evaporator drain lines.</li>\r\n    <li>Any other electrical or plumbing connection not listed above. </li>\r\n    <li>Any condensing unit support not listed on this quote. </li>\r\n    <li>Building walls, roof or floor penetrations, coring and patching.</li>\r\n    <li>Will exclude sleepers, curbs, and pitch pocket for exterior rooftop unit.</li>\r\n    </li></ul>\r\n</ul>",
	PdfTermsShippingSubtitle: "<b>Delivery Terms</b>",
	PdfTermsShippingHasInstallationSubsubtitleLabel:
		"Delivery <b>With Installation</b> ",
	PdfTermsShippingHasInstallationText:
		"<ul>\r\n    <li>Freight price is based on 53' Dry box trailer usage. If the site cannot accommodate this type of vehicle,\r\n        additional charges may apply.\r\n    </li>\r\n</ul>",
	PdfTermsShippingHasInstallationQcGtaSubsubtitleLabel:
		"Delivery <b>With Installation Québec and GTA</b>",
	PdfTermsShippingHasInstallationQcGtaText:
		"<ul>\r\n    <li>Freight price is based on 26' flatbed trailer usage. If the site cannot accommodate this type of vehicle,\r\n        additional charges may apply.\r\n    </li>\r\n</ul>",
	PdfTermsShippingNoInstallationSubsubtitleLabel:
		"Delivery <b>Without Installation</b>",
	PdfTermsShippingNoInstallationText:
		"<ul>\r\n    <li>Allow 30 minutes of off-loading time. Additional charges will be applicable beyond 30 minutes. The driver is not\r\n        responsible for offloading merchandise. It is your responsibility to supply equipment and labour to unload\r\n        truck.\r\n    </li>\r\n    <li>Freight price is based on 53' Dry box trailer usage. If the site cannot accommodate this type of vehicle,\r\n        additional charges may be applicable.\r\n    </li>\r\n    <li><b>IMPORTANT:</b>Norbec cannot guarantee specific delivery time with ANY freight company. Norbec will schedule\r\n        the shipment to be as close as possible to the requested delivery date. Since shipping is handled by a third\r\n        party, Norbec cannot be held responsible for any delays. Price is based on a complete delivery on a single date.\r\n    </li>\r\n</ul>",
	PdfTermsTCSubtitle: "Standard Commercial Terms:",
	PdfTermsTCStandardText:
		"<ol>\r\n    <li>Only Norbec Systems Inc. warranties are applicable to this offer (unless otherwise indicated). The warranty\r\n        document is available on our website and the Level is determined by the level of service selected on your order:\r\n        <ul>\r\n            <li>Norbec One Warranty – PRO package (Box, Refrigeration and Installation supplied by Norbec)</li>\r\n            <li>Norbec Two Warranty – PLUS package (Box & Refrigeration with customer supplied installation)</li>\r\n            <li>Norbec Three Warranty – STANDARD package (Box and Installation supplied by Norbec )</li>\r\n            <li>Norbec Four Warranty – BASIC package (Box only)</li>\r\n        </ul>\r\n    </li>\r\n    <li>This proposal is based on our understanding of the information provided to us. It is the client's responsibility\r\n        to verify its accuracy..\r\n    </li>\r\n    <li>Prices are valid for 15 days and based on delivery within 30 days from the date of submission.</li>\r\n <li>The time frame for the validity of the prices indicated in this quote takes precedence over those from any other documentation or communication.\r\n</li>\r\n    <li>Delivery lead time provided is an estimate. It must not be interpreted as a delivery commitment.</li>\r\n    <li>All customers are subject to a credit evaluation. An advance deposit is required of a minimum of 50% and balance\r\n        is due prior to shipment.\r\n    </li>\r\n    <li>An interest rate of 2.0% per month is applicable to all past due balances.</li>\r\n    <li>All applicable taxes will be added to prices indicated on the proposal.</li>\r\n    <li>Norbec Systems Inc. shall not be held responsible for any cost to customer resulting in a delay in delivering\r\n        the product such as:\r\n        <ul>\r\n            <li>Labour and equipment rental, direct or indirect damages or any consequential damages such as, but not\r\n                limited to, loss of revenue, loss of sales, loss of goods of any nature whatsoever.\r\n            </li>\r\n            <li>The delay is caused by conditions beyond our control such as, but not limited to, force majeure\r\n                (earthquakes, tornadoes, strikes, etc.) lack of raw material, poor quality of raw material, etc.\r\n            </li>\r\n        </ul>\r\n    </li>\r\n    <li>In any circumstances, Norbec Systems Inc.’s responsibilities will be limited to the value of the goods\r\n        purchased.\r\n    </li>\r\n    <li>Norbec Systems Inc. reserves the right to correct any error or omission in this proposal.</li>\r\n    <li>The customer must take delivery of his material on the agreed upon delivery dates. Norbec Systems Inc. reserves\r\n        the right to charge a warehousing fee for any order left on our property for more than 7 calendar days after the\r\n        scheduled delivery date. The customer will become responsible for any damages resulting from the storage.\r\n    </li>\r\n    <li>The customer is responsible for receiving the material at the job site, inspecting, storing and handling it in\r\n        accordance with the instructions provided at the time of delivery entitled: Receiving, Storage, Inspection and\r\n        Handling Guide for Panels.\r\n    </li>\r\n</ol>",
	PdfTermsTCConditionsSubsubtitleLabel:
		"The following conditions are not the responsibility of Norbec Systems Inc. unless noted otherwise within this proposal:",
	PdfTermsTCConditionsText:
		"<ul>\r\n    <li>The area where the cold room is to be installed must be clean, dry and free of any obstacles before\r\n        installation. Panels have been designed to be installed on a level floor.\r\n    </li>\r\n    <li>All penetration (walls, ceilings, floors) and all seals resulting from the penetration.</li>\r\n    <li>Roof frames for outdoor condensing units.</li>\r\n    <li>All electrical connections must be made by a licensed electrical contractor in accordance with all governing\r\n        codes.\r\n    </li>\r\n</ul>",
	PdfTermsShippingTransportSubtitle: "Freight",
	PdfTermsShippingTransportSubsubtitle: "Delivery",
	PdfTermsShippingTransportSubsubtitleInstallationLabel: "With installation",
	PdfTermsShippingTransportSubsubtitleGeneralInstallationText:
		"Freight price is based on 53' trailer usage.  If site cannot accommodate this type of transport, additional charges may be applicable.",
	PdfTermsShippingTransportSubsubtitleQcGtaInstallationText:
		"Freight price is based on 26' trailer usage.  If site cannot accommodate this type of transport, additional charges may be applicable.",
	PdfTermsShippingTransportSubsubtitleNoInstallationLabel:
		"Without installation",
	PdfTermsShippingTransportSubsubtitleNoInstallationText:
		"Allow 30 minutes offloading time.  Additional charges will be applicable beyond 30 minutes.  The driver is not responsible for offloading merchandise.  It is your responsibility to supply materiel and labour to unload truck. Freight price is based on 53' trailer usage.  If site cannot accommodate this type of transport, additional charges may be applicable.<br>\r\n\r\n<b>IMPORTANT :</b> Norbec cannot guarantee specific delivery time with ANY freight company.  Norbec will schedule shipment to be as close as possible to requested delivery date.  As freight is a third-party involvement, Norbec cannot be held responsible for any delays on freight.  Price is based on a complete delivery on a single date.",
	PdfTermsPickUpTitle: "<b>Delivery Terms</b>",
	PdfTermsPickUpSubtitle: "Pick-up at Norbec",
	PdfTermsPickUpText:
		"To pick up your order at Norbec, please make an appointment with the shipping department by email at transport@norbec.com or at 1800-667-2321 #2304 a minimum of 48 hours in advance.\r\nYou must make sure to come with equipment of adequate size and capacity. \r\nThe protection of the load (tarping, cargo security, etc.) will be the responsibility of the carrier. \r\nNorbec cannot be held responsible for any material damage caused by the carrier's equipment.\r\n",
	LoginExpiredLinkTitle: "Link expired",
	LoginExpiredLinkText:
		'Unfortunately, the link you received has expired. Please contact technical support at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a> or <a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>, to obtain a new invitation. ',
	LoginExpiredLinkButtonText: "Return to login page",
	LoginConnectionTitle: "Sign in",
	LoginConnectionEmailLabel: "Email",
	LoginConnectionEmailPlaceholder: "Enter your e-mail address",
	LoginConnectionEmailError: "The email is not valid",
	LoginConnectionPasswordLabel: "Password",
	LoginConnectionPasswordPlaceholder: "Enter Password",
	LoginConnectionPasswordError: "Error message",
	LoginConnectionForgotPasswordLinkText: "Forgot your password?",
	LoginConnectionButtonText: "Sign in",
	LoginConnectionConnectionFailedErrorMessage: "Wrong username and password",
	LoginCreatePasswordNewPasswordTitle: "New Password",
	LoginCreatePasswordNewPasswordText:
		"Please create a new password for your Size-it account.",
	LoginCreatePasswordPasswordLabel: "Password",
	LoginCreatePasswordPasswordPlaceholder: "Enter",
	LoginCreatePasswordConfirmPasswordLabel: "Re-enter your password",
	LoginCreatePasswordConfirmPasswordPlaceholder: "Confirm",
	LoginCreatePasswordCriteriaText: "Your password must include :",
	LoginCreatePasswordCriteria1Text: "8 characters",
	LoginCreatePasswordCriteria2Text: "Upper and lowercase letters",
	LoginCreatePasswordCriteria3Text: "At least one digit",
	LoginCreatePasswordCheckboxTermsText: "I agree to the ",
	LoginCreatePasswordCheckboxTermsTextLink: "Terms of Use",
	LoginCreatePasswordCheckboxNewsletterText: "Subscribe to the newsletter.",
	LoginCreatePasswordButtonText: "Create",
	LoginCreatePasswordSuccessPopupTitle:
		"Success! Your Password has been changed!",
	LoginCreatePasswordSuccessPopupText:
		"A confirmation email has been sent to you. Please use your new password.",
	LoginCreatePasswordSuccessPopupButtonText: "OK",
	LoginForgotPasswordTitleMain: "Reset your password",
	LoginForgotPasswordText:
		"Enter the email address associated with your Size-it account and we will send you an email with a link to reset your password.",
	LoginForgotPasswordButtonText: "Submit",
	LoginForgotPasswordEmailSentTitle: "E-mail sent !",
	LoginForgotPasswordEmailSentText:
		"The password reset email is on its way. Check your mailbox and follow the instructions to reset your password.",
	LoginForgotPasswordSpamCheckText:
		"If you do not receive this email, please check your spam.\r\n",
	LoginForgotPasswordBackToLoginPageText: "Back to",
	LoginForgotPasswordBackToLoginPageLinkText: "login page\r\n",
	MyAccountPasswordChangeSuccess: "Success! Your Password has been changed!",
	ContactBoxChooseProjectManagerLabel:
		"Choose a project manager from the list below:",
	ExtendConfirmationTitle: "Extend",
	ExtendConfirmationDesc:
		"Are you sure you want to extend this quote for an additional 30 days?",
    DuplicateProjectTitle: "Duplicate",
    DuplicateProjectDesc:
		"Please choose a client below:",
    DuplicateProjectCopy: " - copy",
	ModalHelpTitle: "Have a question? Contact us now!",
	ModalHelpDescription:
		"Our hours of operation are: 8:30 to 4:30 PM Eastern Time from Monday to Friday",
	ModalHelpOrBy: "or by email",
	ModalTransportAlertByNorbecTitle: "Choose installation by Norbec?",
	ModalTransportAlertByNorbecText:
		'This action will automatically deselect the "Pick up at Norbec" option. Are you sure you want Norbec to do the installation?',
	ModalTransportAlertPickUpTitle: "Choose pick up at Norbec?",
	ModalTransportAlertPickUpText:
		'This action will automatically deselect the "I want Norbec to do the installation" option. Are you sure you want to pick up your order at Norbec?',
	AlertChangesSavedSuccess: "Changes saved successfully!",
	AlertExtend:
		"The quote was successfully extended for 30 days. Please run the submission to see the changes.",
	AlertDiscount: "The discount percentage has been saved successfully !",
	AlertMargin: "The margin percentage has been successfully saved!",
	AlertDeliveryAddress: "Delivery address successfully saved!",
	AlertNewsletterSubscribed: "You are now subscribed to the newsletter!",
	AlertNewsletterUnsubscribed:
		"Your email has been removed from the mailing list.",
	AlertDeliveryDate: "Delivery date successfully saved!",
	AlertTransportPrice: "Transport price successfully saved!",
	AlertInstallationPrice: "Installation price successfully saved!",
	AlertTransportValidated: "Transport price successfully validated!",
	AlertInstallationValidated: "Installation price successfully validated!",
	OnboardingHalfHalfTitle: "Online cold room configurator by Norbec ",
	GeneralCopyright: "© 2020, Norbec Inc. All Rights Reserved",
	DashboardTitle: "Configurations",
	HeaderHelpButtonLabel: " Help Center",
	LabelStatusActive: "Active",
	LabelStatusPartial: "Partial",
	LabelStatusCompleted: "Completed",
	LabelStatusOrdered: "Ordered",
	LabelStatusArchived: "Archived",
	LabelStatusExpired: "Expired",
	ProjectDetailsContactSalesRep: "Representative",
	ProjectDetailsContactProjectManager: "Project Manager",
	ProjectDetailsTabDetails: "Details",
	ProjectDetailsTabClient: "Client",
	ProjectDetailsTabDelivery: "Shipping",
	ProjectDetailsTabTransportInstallation: "Freight & Installation",
	ProjectDetailsTabDiscount: "Rebate",
	ProjectDetailsTabMargin: "Markup",
	ProjectDetailsDetailsTitle: "General Information",
	ProjectDetailsDetailsRefNumberLabel: "Reference #",
	ProjectDetailsDetailsLastUpdateLabel: "Last backup",
	ProjectDetailsDetailsCurrencyLabel: "Currency",
	ProjectDetailsDetailsCreatedByLabel: "Created by",
	ProjectDetailsDetailsSubmissionDateLabel: "Date of quote",
	ProjectDetailsDetailsExpirationDateLabel: "Expiry date",
	ProjectDetailsDetailsInternalQuoteNumberLabel: "Internal Quote #",
	ProjectDetailsTabClientGeneralInfoLabel: "General information",
	ProjectDetailsTabClientContactLabel: "Contact",
	ProjectDetailsTabClientOrganisationLabel: "Organization",
	ProjectDetailsTabClientAddressLabel: "Address",
	ProjectDetailsTabClientPhoneLabel: "Phone",
	ProjectDetailsTabClientFaxLabel: "Fax",
	ProjectDetailsTabClientEmailLabel: "E-mail",
	ProjectDetailsTabClientFullNameLabel: "Full Name",
	ProjectDetailsTabClientContactPhoneLabel: "Phone",
	ProjectDetailsTabClientExtensionLabel: "Extension",
	ProjectDetailsTabClientCellularLabel: "Cell Phone",
	ProjectDetailsTabClientContactEmailLabel: "E-mail",
	ProjectDetailsTabClientButtonEditLabel: "Edit",
	ProjectDetailsTabClientFullNamePlaceholder: "Enter",
	ProjectDetailsTabClientContactPhonePlaceholder: "(___) ___-____",
	ProjectDetailsTabClientExtensionPlaceholder: "Enter",
	ProjectDetailsTabClientCellularPlaceholder: "(___) ___-____",
	ProjectDetailsTabClientEmailPlaceholder: "Enter",
	ProjectDetailsTabClientFrench: "French",
	ProjectDetailsTabClientEnglish: "English",
	ProjectDetailsTabClientLanguageLabel: "Language of communication",
	TabShippingSectionAddressAddressTitle: "Address",
	TabShippingIntroTextDeliveryByNorbec: "Delivery by Norbec",
	TabShippingIntroTextDeliveryByClient:
		"The customer is responsible for the delivery",
	TabShippingSectionContactTitle: "Contact",
	TabShippingSectionContactNameLabel: "Name",
	TabShippingSectionContactPhoneLabel: "Phone",
	TabShippingSectionContactPhoneExtLabel: "Extension",
	TabShippingSectionContactEmailLabel: "E-mail",
	TabShippingSectionDateTitle: "Date",
	TabShippingSectionAddressAddressLabel: "Civic, street, office number",
	TabShippingSectionAddressMoreInfoLabel: "Additional information",
	TabShippingSectionAddressCountryLabel: "Country",
	TabShippingSectionAddressStateLabel: "Province",
	TabShippingSectionAddressCityLabel: "City",
	TabShippingSectionAddressZiipCodeLabel: "Postal Code",
	TabShippingSectionAddressShippingDatelabel: "Preferred delivery date",
	TabShippingSectionAddressAddressPlaceholder: "Enter",
	TabShippingSectionAddressMoreInfoPlaceholder: "Enter",
	TabShippingSectionAddressCityPlaceholder: "Enter",
	TabShippingSectionAddressZiipCodePlaceholder: "Enter",
	TabTransportInstallationSectionTransportTitle: "Freight",
	TabTransportInstallationSectionPalletTitle: "Skid details",
	TabTransportInstallationSectionTableHeaderSid: "Skid",
	TabTransportInstallationSectionTableHeaderWidth: "Width (in)",
	TabTransportInstallationSectionTableHeaderLength: "Length (in)",
	TabTransportInstallationSectionTableHeaderHeight: "Height (in)",
	TabTransportInstallationSectionTableHeaderWeight: "Weight (lbs)",
	TabTransportInstallationSectionTableHeaderNote: "Notes",
	TabTransportInstallationSectionTableNoData:
		"There is no information at the moment.",
	TabTransportInstallationSectionInstallationTitle: "Installation",
	TabTransportInstallationIntroText:
		"If the country, province or city of delivery is changed, there will be an impact on the installation and freight costs and if these change, the quote will have to be resubmitted. ",
	TabTransportInstallationSectionTransportCheckboxLabelDeliveryByNorbec:
		"Delivery by Norbec",
	TabTransportInstallationSectionTransportCheckboxLabelPickUpAtNorbec:
		"Pick-up at Norbec",
	TabTransportInstallationSectionPalletViewButtonText: "View",
	TabTransportInstallationSectionPalletCloseButtonText: "Close",
	TabTransportInstallationInputPriceLabel: "Price",
	TabTransportInstallationCheckboxInstallByNorbecLabel:
		"I choose the installation service",
	TabTransportInstallationNoCalculationTitle: "Price not calculated",
	TabTransportInstallationNoCalculationText:
		"The quote was sent to Norbec. You will receive shipping and installation costs within 1-2 business days.",
	TabDiscountSectionTitle: "Rebate",
	TabDiscountIntroText: "Discount given to the customer",
	TabDiscountDiscountInputLabel: "Rebate Percentage",
	TabMarkupSectionTitle: "Markup ",
	TabMarkupIntroText: "A percentage added to the selling price ",
	TabMarkupMarkupInputLabel: "Markup Percentage",
	TabTransportInstallationNoCalculationTextActiveStatus:
		"Installation & freights costs can not be calculated at this time. Please continue the configuration with the information entered and you will receive your quote within 1-2 business days.",
	MenuLinkLabelConfiguration: "Configurations",
	MenuLinkLabelContact: "Contact",
	MenuLinkLabelContacts: "Contacts",
	MenuLinkLabelClients: "Customers",
	MenuLinkLabelFaq: "FAQ",
	MenuLinkLabelCondition: "Terms of use",
    MenuLinkLabelPrivacyPolicy: "Privacy policy",
    MenuLinkLabelGovernancePolicy: "Personal information and \ndata governance policy",
	MenuLinkLabelLangEn: "English",
	MenuLinkLabelLangFr: "Français",
	MenuLinkUserMyAccount: "My Account",
	MenuLinkUserLogout: "Logout",
	MyAccountTitle: "My Account",
	MyAccountPersonalInfo: "Personal information",
	MyAccountNewPassword: "New Password",
	MyAccountCurrentPassword: "Current Password",
	MyAccountUsername: "Username",
	MyAccountEmail: "E-mail",
	MyAccountLanguage: "Language of communication",
	MyAccountPassword: "Password",
	MyAccountLastUpdate: "Last update",
	MyAccountNewsletter: "Newsletter",
	MyAccountNewsletterText:
		"Subscribe to our newsletter to be informed by email of new relevant content and exclusive news.",
	MyAccountNewsletterSuscribed: "You are now subscribed to the newsletter",
	MyAccountNewsletterSuscribe: "Subscribe",
	MyAccountNewsletterUnsuscribe: "Unsubscribe",
	PdfEditActionLabel: "Edit",
	TermsMvpTitle: "Terms of use",
	TermsMvpContent:
		'<p class="indent">Please read the following terms and conditions, together with any documents they incorporate by reference\r\n        (collectively, the &ldquo;<strong>Agreement</strong>&rdquo;) carefully before you (the\r\n        &ldquo;<strong>Client</strong>&rdquo;) start to use the Software and Software Services (as defined below). You\r\n        accept and agree to be bound and abide by this Agreement. If you do not agree with all of the terms and conditions\r\n        in this Agreement, you must not access or use the Software and Software Services.</p>\r\n\r\n    <ol class="main-ol">\r\n        <li class="more-space">\r\n            <span class="more-space">\r\n                <strong>DESCRIPTION OF THE SERVICES AND PERMITTED USE </strong>\r\n            </span>\r\n            <ol class="decimal">\r\n                <li>Norbec shall make available to Client the (Size-it) (the &ldquo;<strong>Software</strong>&rdquo;) and associated\r\n                    services (&ldquo;<strong>Software Services</strong>&rdquo;), under the terms and conditions of this Agreement.\r\n                </li>\r\n                <li>Subject to Client abiding by the terms and conditions of this Agreement, Client shall have the limited,\r\n                    non-exclusive, non-transferable, and non-sublicensable right to use and access the Software remotely via the\r\n                    internet solely for Client\'s internal use (the &ldquo;<strong>Permitted Use</strong>&rdquo;).\r\n                </li>\r\n                <li>The Permitted Use includes Client\'s right to use the Software to input, upload, transmit or otherwise make\r\n                    available to Norbec texts, videos, images, pictures, and/or other data related to its business as well as\r\n                    parameters, specifications and details with respect to the customizations required for Client&rsquo;s coolers,\r\n                    freezers, combos, refrigerated or dry storage rooms and units (together, the &ldquo;<strong>Client Data</strong>&rdquo;).\r\n                </li>\r\n            </ol>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>SUPPORT SERVICES </strong>\r\n            <p>Norbec shall provide Client with Software maintenance and problem management support services as described in this\r\n                Section 2. Norbec shall grant standard problem resolution services from (2 to 5 business days), and such services\r\n                shall be accessible by Client via Norbec&rsquo;s contact support link or by email (sizeit@norbec.com). Norbec will\r\n                use commercially reasonable efforts to correct or eliminate any defect, error, bug or other failure of all or part\r\n                of the Software (&ldquo;<strong>Issues</strong>&rdquo;). The foregoing shall be Client\'s sole and exclusive remedy\r\n                for resolution of Issues and Norbec does not guarantee or warrant that all Issues are or will be resolved or\r\n                eliminated or correctable or that a workaround will be made available.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>AVAILABILITY </strong>\r\n            <p>Norbec will use commercially reasonable efforts to make the Software and Software Services usable on an uninterrupted\r\n                basis to Client other than during any period of scheduled maintenance determined by Norbec. However, Norbec will not\r\n                be liable if for any reason all or any part of the Software or Software Services is unavailable at any time or for\r\n                any period.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <span class="more-space">\r\n                <strong>SOFTWARE ACCESS AND ACCOUNT SECURITY</strong>\r\n            </span>\r\n            <ol>\r\n                <li>If Client is provided with, a user name, password, or any other piece of information as part of Norbec&rsquo;s\r\n                    security procedures (&ldquo;<strong>Access Credentials</strong>&rdquo;), such Access Credentials must be treated\r\n                    as confidential and must not be disclosed to any other person or entity.\r\n                </li>\r\n                <li>Client must immediately notify Norbec of any unauthorized access to or use of its Access Credentials or any\r\n                    other breach of security and agrees to ensure logoff from its account at the end of each session and use\r\n                    particular caution when accessing its account from a public or shared computer so that others are not able to\r\n                    view or record its Access Credentials.\r\n                </li>\r\n                <li>Client has and will retain sole responsibility for: (a) all Client Data, including its content and use; (b) all\r\n                    information, instructions and materials provided by or on behalf of Client in connection with the Software and\r\n                    Software Services; (c) any computer systems used to access the Software and Software Services; (d) the security\r\n                    and use of its Access Credentials; and (e) all access to and use of the Software and Software Services using its\r\n                    Access Credentials, with or without Client&rsquo;s knowledge or consent, including all results obtained from,\r\n                    and all conclusions, decisions and actions based on, such access or use.\r\n                </li>\r\n            </ol>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>RESTRICTIONS ON USE </strong>\r\n            <p>Except as otherwise expressly provided herein, Client shall not: (i) provide, disclose, sublicense or otherwise\r\n                permit any person to access, use, read, disseminate, transmit, download or reproduce the Software or any of its\r\n                related documentation; (ii) adapt, translate, change, customize, enhance, partially delete, alter or otherwise\r\n                modify the Software in any manner or to any extent whatsoever; (iii) to the maximum extent permitted by applicable\r\n                law, disassemble, decompile, reverse engineer, or otherwise investigate all or any part of the Software; (iv)\r\n                introduce viruses, worms, trojan horses and other items of a disabling or destructive nature within the Software or\r\n                Norbec\'s systems; (v) probe, scan, or test the vulnerability of any of Norbec\'s system or network, unless expressly\r\n                authorized in writing by Norbec; (vi) disclose the results of any software benchmark tests without Norbec&rsquo;s\r\n                prior written consent; (vii) have any right to access or obtain a copy of the object code or source code to the\r\n                Software; (viii) forge any IP address information or login information or otherwise circumvent the Software\'s access\r\n                mechanisms; (ix) make use of the Software Services with materials of any kind that violates applicable law or that\r\n                violates or infringes upon the intellectual property rights of any third party or that contain libelous, defamatory\r\n                or otherwise unlawful material; and/or (x) sell, assign, pledge, sublicense, or otherwise transfer its rights under\r\n                this Agreement (except as otherwise provided in this Agreement).</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong> </strong><strong>SUSPENSION OF SERVICES</strong>\r\n            <p>Norbec reserves the right to restrict Client&rsquo;s access to the Software and Software Services, including by\r\n                disabling the Access Credentials, if at any time, in Norbec&rsquo;s opinion, Client has violated any provision\r\n                whatsoever of this Agreement. It is in Norbec&rsquo;s sole discretion to determine whether this Agreement has been\r\n                violated for the purposes of the sanctions herein.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>TERMINATION OF SERVICES</strong>\r\n            <p>Norbec reserves the right to terminate access to the Software and Software Services at any time. The provisions set\r\n                forth in the following sections, and any other right or obligation of the parties in this Agreement that, by its\r\n                nature, should survive termination or expiration of this Agreement, will survive any expiration or termination of\r\n                this Agreement: Sections 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18 and 19.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>PERSONAL INFORMATION</strong>\r\n            <p>Client acknowledges and agrees that the use of the Software and Software Services, including the Client Data, may\r\n                include the manipulation of information relating to identified or identifiable individuals that is protected by law\r\n                (&ldquo;<strong>Personal Information</strong>&rdquo;), and it is Client\'s sole and exclusive responsibility to\r\n                obtain the required consents for the use of any Personal Information and Client Data under this Agreement or\r\n                otherwise. Client expressly acknowledges and agrees that the Software Services provided hereunder are solely for the\r\n                benefit of Client and not for the benefit of any other person, and that any such other person\'s sole contractual\r\n                recourse for unauthorized use of their Personal Information shall be against Client.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>CLIENT DATA PROCESSING </strong>\r\n            <p>Client acknowledges that by using the Software and Software Services, it will make available Client Data to Norbec.\r\n                Client hereby grants to Norbec a limited, non-exclusive and fully paid-up license to access and use the Client Data\r\n                in order to perform its obligations under this Agreement. Norbec is hereby granted a license to use and aggregate\r\n                Client Data for use in an anonymized manner. Client acknowledges that Client Data may be processed and stored in\r\n                Canada and in other countries where Norbec is established or may become established in the future and that the\r\n                governments, courts or law enforcement or regulatory agencies of these jurisdictions may be able to obtain\r\n                disclosure of Client Data in accordance with local laws and regulations.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <span class="more-space">\r\n                <strong>INTELLECTUAL PROPERTY</strong>\r\n            </span>\r\n            <ol>\r\n                <li>\r\n                    All rights, titles, and interests in and to the Software and its related documentation (inclusive of all\r\n                    enhancements, changes, and modifications to the Software and its related documentation), including all intellectual\r\n                    property and other proprietary rights therein are owned solely and exclusively by Norbec and/or its third party\r\n                    licensors. Nothing in this Agreement shall, or shall be deemed or construed to, assign, transfer or convey to or\r\n                    vest in Client any title, rights or interest in or to any intellectual property, including in or to the Software or\r\n                    its related documentation, other than the rights specifically and expressly granted herein. Norbec reserves all\r\n                    rights not expressly granted to Client hereunder.\r\n                </li>\r\n                <li>\r\n                    Subject to the limited licenses granted herein, all rights, titles and interests in and to the Client Data\r\n                    including all intellectual property and other proprietary rights therein are owned solely and exclusively by Client\r\n                    and/or third parties from whom the Client has acquired the necessary consent to use data.\r\n                </li>\r\n            </ol>\r\n        </li>\r\n\r\n        <li>\r\n            <span class="more-space">\r\n                <strong>REPRESENTATIONS AND WARRANTIES</strong>\r\n            </span>\r\n            <ol>\r\n                <li>\r\n                    <span>Client hereby represents and warrants that:</span>\r\n                    <ol class="roman">\r\n                        <li>it has the full right, power and authority to enter into this Agreement, grant the licenses set forth herein and\r\n                            to discharge its obligations here under;\r\n                        </li>\r\n                        <li>its compliance with the terms and conditions in this Agreement and the performance of its obligations hereunder\r\n                            does not and will not violate any agreement to which it is a party or by which it is or will be otherwise bound;\r\n                        </li>\r\n                        <li>it shall at all times comply with applicable law and this Agreement (including any applicable privacy or data\r\n                            protection laws);\r\n                        </li>\r\n                        <li>the Client Data does not and will not infringe or misappropriate any rights of any third party nor does it or\r\n                            will it violate any law, statute, ordonnance or regulation;\r\n                        </li>\r\n                        <li>the Client Data provided does not and will not contain any viruses, spyware, adware or other programming\r\n                            routines that may detrimentally interfere with the Software or any computer systems, whether those of Norbec or\r\n                            any third party; and\r\n                        </li>\r\n                        <li>it has obtained and will obtain all necessary rights and consents from any identified or identifiable person\r\n                            concerned by the Client Data, prior to such Client Data being made available by Client through the Software and\r\n                            Software Services.\r\n                        </li>\r\n                    </ol>\r\n                </li>\r\n            </ol>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>INDEMNIFICATION</strong>\r\n            <p>Client hereby agrees to defend, indemnify and hold Norbec harmless from and against any and all claims, actions or\r\n                proceedings of any kind and from any and all damages, judgments, losses, liabilities, costs and expenses, including\r\n                reasonable attorney\'s fees and expenses (including any incurred in enforcement of this provision), relating to or\r\n                arising out of (a) Client&rsquo;s misuse of the Software or Software Services, (b) Client&rsquo;s violation of\r\n                applicable laws, (c) Client&rsquo;s breach of the terms this Agreement, and (d) the use or processing of Client\r\n                Data, including any claim that such use or processing of Client Data infringes upon, violates or misappropriates,\r\n                any rights whatsoever of a third party, including the intellectual property rights.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>SOFTWARE AND SOFTWARE SERVICES - DISCLAIMER</strong>\r\n            <p>THE SOFTWARE AND SOFTWARE SERVICES ARE PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS-AVAILABLE&rdquo;, AND WITHOUT\r\n                WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW,\r\n                NORBEC DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, ALL IMPLIED WARRANTIES OF\r\n                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. NORBEC DOES NOT WARRANT OR MAKE ANY\r\n                REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE USE OF THE SOFTWARE AND SOFTWARE SERVICES IN TERMS OF THEIR\r\n                CORRECTNESS, ACCURACY, RELIABILITY, OR OTHERWISE.</p>\r\n            <p>THE USE OF THE SOFTWARE AND SOFTWARE SERVICES IS DONE AT CLIENT&rsquo;S OWN RISK AND WITH CLIENT&rsquo;S AGREEMENT\r\n                THAT IT WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO ITS COMPUTER SYSTEM OR ANY LOSS OF DATA THAT MAY RESULT FROM\r\n                SUCH USE.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>OPERATION OF SOFTWARE AND SOFTWARE SERVICES - DISCLAIMER </strong>\r\n            <p>NORBEC ENDEAVORS TO MAINTAIN THE OPERATION OF THE SOFTWARE AND SOFTWARE SERVICES, BUT IS NOT, AND CANNOT BE,\r\n                RESPONSIBLE FOR THE RESULTS OF ANY DEFECTS THAT MAY EXIST IN THEM. NORBEC MAKES NO WARRANTY THAT (I)&nbsp;THE\r\n                SOFTWARE AND SOFTWARE SERVICES WILL MEET THE CLIENT&rsquo;S REQUIREMENTS OR NEEDS; (II) ACCESS TO THE SOFTWARE AND\r\n                SOFTWARE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, FREE OF VIRUSES, WORMS, TROJAN HORSES OR OTHER HARMFUL\r\n                COMPONENTS, OR FREE OF DEFECTS OR ERRORS; (III) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SOFTWARE AND\r\n                SOFTWARE SERVICES WILL BE ACCURATE OR RELIABLE; OR (IV)&nbsp;DEFECTS WILL BE CORRECTED. CLIENT (AND NOT NORBEC)\r\n                ASSUMES THE ENTIRE COST OF ALL SERVICING, REPAIR, OR CORRECTION THAT MAY BE NECESSARY FOR CLIENT&rsquo;S COMPUTER\r\n                EQUIPMENT OR MOBILE DEVICE AND/OR SOFTWARE AS A RESULT OF ANY VIRUSES, ERRORS OR ANY OTHER PROBLEMS WHATSOEVER\r\n                CLIENT MAY HAVE AS A RESULT OF USING THE SOFTWARE OR SOFTWARE SERVICES.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>LIMITATION OF LIABILITY </strong>\r\n            <p>IN NO EVENT SHALL NORBEC HAVE ANY LIABILITY TO CLIENT FOR ANY LOSS OF PROFITS, REVENUES OR DIRECT, INDIRECT,\r\n                INCIDENTAL, EXEMPLARY, SPECIAL, PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND OR NATURE WHATSOEVER AND REGARDLESS OF\r\n                THE FORM OR CAUSE OF ACTION, EVEN IF SUCH DAMAGES ARE FORESEEABLE OR NORBEC HAS BEEN ADVISED OF THE POSSIBILITY OF\r\n                SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY IN THIS AGREEMENT, IN NO CASE SHALL NORBEC\'S LIABILITY WITH\r\n                RESPECT TO ANY AND ALL INCIDENTS ARISING OUT OF OR RELATED TO THIS AGREEMENT, EXCEED IN THE AGGREGATE THE AMOUNTS\r\n                RECEIVED BY NORBEC RELATING TO CLIENT&rsquo;S USE OF THE SOFTWARE OR SOFTWARE SERVICES REGARDLESS OF THE FORM OF\r\n                ACTION OR THEORY OF LIABILITY.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>SEVERABILITY</strong>\r\n            <p>If any provision of this Agreement is be found to be unlawful, void, or for any reason unenforceable, then that\r\n                provision shall be deemed severable and the validity and enforceability of any remaining provisions will not be\r\n                affected.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>NO WAIVER</strong>\r\n            <p>No failure on the part of Norbec to enforce its rights under this Agreement shall constitute a waiver of any of\r\n                Norbec\'s rights hereunder.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>MODIFICATIONS</strong>\r\n            <p>Norbec may modify or change the terms of the Agreement from time to time, or add or discontinue any aspect, content\r\n                or feature of the Software and Software Services at its sole discretion. You will be made aware of such changes and\r\n                if you do not agree with all of them, you must cease all access and use the Software and Software Services. You also\r\n                agree to periodically review the terms and conditions in order to be aware of any such modifications and your\r\n                continued use shall be your acceptance of these.</p>\r\n        </li>\r\n\r\n        <li>\r\n            <strong>APPLICABLE LAW AND JURISDICTION</strong>\r\n            <p>This Agreement and any disputes arising hereunder or related to such (whether for breach of contract, tortious\r\n                conduct or otherwise) will be governed by the laws in effect in the Province of Quebec, without reference to its\r\n                conflicts of law principles. Any legal actions, suits or proceedings arising out of this Agreement (whether for\r\n                breach of contract, tortious conduct or otherwise) will be brought exclusively in the courts of the Province of\r\n                Quebec, located in the District of Montreal, and Norbec and Client hereby accept and submit to the personal\r\n                jurisdiction of these courts with respect to any legal actions, suits or proceedings arising out of this\r\n                Agreement.</p>\r\n        </li>\r\n    </ol>',
	TableError: "Error... Please try again.",
	TableBodyEmptyDataSourceMessage: "No records to display",
	TableBodyFilterRowFilterPlaceHolder: "",
	TableBodyFilterRowFilterTooltip: "Filter",
	TableHeaderActions: "Actions",
	TablePaginationFirstTooltip: "First page",
	TablePaginationPreviousTooltip: "Previous page",
	TablePaginationNextTooltip: "Next page",
	TablePaginationLabelDisplayedRows: "{from}-{to} of {count}",
	TablePaginationLabelRowsPerPage: "lines per page",
	TablePaginationLastTooltip: "Last page",
	TablePaginationLabelRowsSelect: "lines",
	TableToolbarAddRemoveColumns: "Add or remove columns",
	TableToolbarNRowsSelected: "{0} line(s) selected",
	TableToolbarShowColumnsTitle: "View columns",
	TableToolbarExportTitle: "Export",
	TableToolbarExportCSVName: "Export to CSV",
	TableToolbarExportPDFName: "Export to PDF",
	TableToolbarSearchTooltip: "Search",
	TableToolbarSearchPlaceholder: "Search",
	TableToolbarClearSearchAriaLabel: "Clear",
	TableToolbarRefreshAriaLabel: "Refresh",
	TableToolbarRefreshTooltip: "Refresh data",
	TableColName: "Project name",
	TableColEpicorCustId: "Client ID",
	TableColEpicorName: "Client",
	TableColUserName: "Created by",
	TableColRefNumber: "Reference #",
	TableColInternalRefNumber: "Internal Quote #",
	TableColLastUpdate: "Last update",
	TableColQuotedDate: "Quote date",
	TableColStatus: "Status",
	CreateProjectModalDescription: "Please choose a client below:",
	CreateProjectNoClientFound: "No clients found",
	CreateProjectPlaceholder: "Select to filter",
	CreateProjectLabel: "Client",
	CreateProjectModalTitle: "Create a new configuration",
	ActionMenuContinue: "Next",
	ActionMenuDetails: "See details",
	ActionMenuModify: "Edit",
	ActionMenuSubmission: "See quote",
	ActionMenuExtend: "Extend quote",
	ActionMenuContact: "Contact Size-it",
	ActionMenuArchive: "Archive",
	ActionMenuRestore: "Restore",
    ActionMenuDuplicate: "Duplicate",
	KeyFaqQ1: "What is the advantage of using the Size-it configurator?",
	KeyFaqA1:
		"The Size-it allows you to get a quote quickly, 24 hours a day, 7 days a week in just a few clicks.",
	KeyFaqQ2: "Where do I sign up?",
	KeyFaqA2:
		'To sign up for a Size-it account, please contact us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a>.',
	KeyFaqQ3: "How can I change my user information?",
	KeyFaqA3:
		'To modify your user information, please contact us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a>.',
	KeyFaqQ4: "How can I check the status of my quote?",
	KeyFaqA4: "Please visit the portal to check the status of your order.",
	KeyFaqQ5: "How will I receive updates on my order?",
	KeyFaqA5:
		"All order updates will be sent to the email address used at the time of ordering. For this reason, please ensure that you provide a valid email address when placing your order. You can also consult the Portal for more information on the status of your order. ",
	KeyFaqQ6: "Can I change my order once it is approved?",
	KeyFaqA6:
		"Once your order has been placed, it is not possible to modify or cancel it. It is important to make sure that all the information in the quote is confirmed since everything is sent to production once approved. If there is an error on your order, please contact your project manager as soon as possible.",
	KeyFaqQ7: "Can I cancel my order once it is approved?",
	KeyFaqA7:
		"Once your order has been placed, it is not possible to modify or cancel it. It is important to make sure that all the information in the quote is confirmed since everything is sent to production once approved. If there is an error on your order, please contact your project manager as soon as possible.",
	KeyFaqQ8: "How do I convert my quote into an order?",
	KeyFaqA8:
		"To place your quote in order, please send your quote number, P.O. number and signed approval drawing to project@norbec.com.",
	KeyFaqQ9: "I lost my quote, what can I do?",
	KeyFaqA9:
		'Please contact us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a> or <a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a> or re-submit.',
	KeyFaqQ10: "My browser does not allow me to run the configurator.",
	KeyFaqA10:
		'The configurator should work on all browsers. We recommend using Google Chrome. Contact <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a> for any questions.My browser does not allow me to run the configurator.',
	KeyFaqQ11: "I didn't receive an email confirmation, what can I do?",
	KeyFaqA11:
		'Please check your junk mail. You should receive a confirmation shortly. If you do not receive a confirmation after 30 minutes, please contact us at <a href="mailto:[VariableEmailSizeIt]">[VariableEmailSizeIt]</a> or <a href="tel:[VariablePhoneNumberSizeIt]">[VariablePhoneNumberSizeIt]</a>.',
	KeyFaqQ12: "Can we copy an existing quote?",
	KeyFaqA12: "It is currently not possible to duplicate a quote. ",
	KeyFaqQ13: "What is the Warranty? ",
	KeyFaqA13:
		'Visit the following link for more details on <a href="https://norbec.com/technical-sheets-modaspace/Norbec_Warranty_ModaSpace_EN.pdf">warranties</a>.\r\n',
	KeyFaqQ14: "I don't know the place of delivery, what can I do?",
	KeyFaqA14:
		"The calculation of the installation and delivery price will be made after confirmation of the place of delivery. ",
	KeyFaqQ15:
		"I would like to add an option (dimensions, options, others) that is not included in the Size-it configurator, what should I do?",
	KeyFaqA15:
		"The Size-it configurator does not allow additional options. Please contact quote@norbec.com for more information about our product offerings.",
	KeyFaqQ16: "What is the lead time?",
	KeyFaqA16:
		"Delivery time is three weeks from the reception of the P.O. and the signed approval drawing. ",
	KeyFaqQ17:
		"Door opening direction: what is the difference between left and right opening?",
	KeyFaqA17:
		"Left opening: when looking at the door from outside the room, the hinges will be on the left. Right opening: when looking at the door from outside the room, the hinges will be on the right. ",
	KeyFaqQ18: "Can we have two doors in a room?",
	KeyFaqA18:
		"The Size-it configurator does not allow this type of configuration at the moment. Please contact quote@norbec.com for more information about our product offerings.",
	KeyFaqQ19: "Can I change the position of the door once at the job site?",
	KeyFaqA19:
		"Yes, the universal fastening systems provided allow the position of the door to be changed, even after arrival at the job site.",
	KeyFaqQ20: "What is the load-bearing capacity of the cold room ceiling?",
	KeyFaqA20:
		"Cold room ceilings are designed to support a load of 10 lbs / sq.ft. in uniformly distributed live load with a maximum point live load limit of 300 lbs.",
	KeyFaqQ21: "What is the load-bearing capacity of the cold room floor?",
	KeyFaqA21:
		"600 lbs. per sq. ft. for an evenly distributed dead load. For live loads (user and/or cart) a maximum of 250 lbs. is allowed.",
	KeyFaqQ22: "Can I store materials above the cold room?",
	KeyFaqA22:
		"Cold room ceilings are not designed for storage. Only the refrigeration system and occasional access for maintenance by 1 man and his equipment is permitted.",
	KeyFaqQ23: "Can I wash the cold room with a pressure washer?",
	KeyFaqA23:
		"It is not recommended to use a pressure machine to clean the cold room. It is recommended to use a mild cleaner and hand wash to clean the cold room. ",
	KeyFaqQ24: "Is it possible to install a ModaSPACE room outdoors?",
	KeyFaqA24:
		"ModaSPACE rooms are designed for indoors. It is therefore not possible to install them outside. Please refer to the outdoor cold room line ExSPACE and ExSPACE-Go.",
	KeyFaqQ25:
		"Why do I need to provide the distance between the evaporator and the compressor?",
	KeyFaqA25:
		"To be able to provide you with an installation price. The installation price varies according to the distance.",
	KeyFaqQ26:
		"What is the maximum distance between the cold room and the refrigeration systems? ",
	KeyFaqA26:
		"Our systems can go up to 75'. Beyond this distance, the systems will be custom-made.",
	CustomerTitleName: "Name",
	CustomerTitleEpicorCustId: "EpicorCustId",
	CustomerTitleType: "Type",
	CustomerTitleSalesrepCode: "SalesrepCode",
	CustomerTitleVille: "City",
	CustomerTitlePays: "Country",
	CustomerTitlePhone: "Phone",
	CustomerTitleTerritoire: "Territory",
	CustomerTitleActive: "Status",
	CustomerTitleTerms: "Terms",
	CustomerStatusActive: "Active",
	CustomerStatusInactive: "Inactive",
	CreateCustomerTitle: "Create a new prospect",
	CreateCustomerEditTitle: "Customer details",
	CreateCustomerDescription: "Please fill in the information below : ",
	CreateCustomerPhoneInputError: "The Phone number is not valid",
	CreateCustomerFaxInputError: "The Fax number is not valid",
	CreateCustomerOptionUSA: "United States",
	CreateCustomerOptionCAN: "Canada",
	CreateCustomerContactName: "Name",
	CreateCustomerContactFirstname: "Firstname",
	CreateCustomerContactLastname: "Lastname",
	CreateCustomerContactFunction: "Title",
	CreateCustomerContactRole: "Role",
	CreateCustomerContactEmail: "Email",
	CreateCustomerContactPhoneNum: "Telephone",
	CreateCustomerInputRequired: "required",
	CreateCustomerOptionLangueFR: "French",
	CreateCustomerOptionLangueEN: "English",
	CreateCustomerOptionPotentielA: "A",
	CreateCustomerOptionPotentielB: "B",
	CreateCustomerOptionPotentielC: "C",
	CreateCustomerLabelGeneralInfos: "General Information",
	CreateCustomerInputName: "Prospect Name",
	CreateCustomerInputEmail: "Email",
	CreateCustomerInputPhoneNum: "Telephone",
	CreateCustomerInputStatus: "Status",
	CreateCustomerInputFax: "Fax",
	CreateCustomerLabelAdresse: "Address",
	CreateCustomerInputStreet1: "Civic no., street name, suite",
	CreateCustomerInputStreet2: "Additional information",
	CreateCustomerInputCountry: "Country",
	CreateCustomerInputProvince: "Province",
	CreateCustomerInputCity: "City",
	CreateCustomerInputCodePostal: "Postal Code",
	CreateCustomerLabelDetails: "Details",
	CreateCustomerInputTerritory: "Territory",
	CreateCustomerInputSalesRep: "Sales Rep.",
	CreateCustomerInputGrpIndustrie: "Group (Industry)",
	CreateCustomerInputPotentiel: "Potential",
	CreateCustomerInputLangue: "Language of communication",
	CreateCustomerLabelContacts: "Contacts",
	CreateCustomerContactsSearch: "Search...",
	CreateCustomerContactsEmpty: "No records to display",
	CreateCustomerContactsDeleteRow:
		"Are you sure you want to delete this contact ?",
	CreateCustomerContactslabelRowsSelect: "Rows",
	CreateCustomerContactsMuiTableActionAdd: "Add",
	CreateCustomerContactsMuiTableActionEdit: "Edit",
	CreateCustomerContactsMuiTableActionDelete: "Delete",
	CreateCustomerContactsMuiTableActionSave: "Save",
	CreateCustomerContactsMuiTableActionCancel: "Cancel",
    DoorsRampeDescription: "This interior ramp is designed to carry heavy loads in and out of your walk-ins and provide easy access with a cart. By choosing this option, the floor(s) will be automatically reinforced with 1/2\" plywood. Dimensions: 36\" deep. Ramp finish: Nextgrip slip resistant floor.",
};

export default data;
